import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'online-task-inspection',
    pathMatch: 'full',
  },
  {
    path: 'online-task-inspection',
    loadChildren: () =>
      import('./online-task-inspection/online-task-inspection.module').then(
        (m) => m.OnlineTaskInspectionModule
      ),
  },
  {
    path: 'forbidden',
    loadChildren: () =>
      import('./error/forbidden/forbidden.module').then(
        (m) => m.ForbiddenModule
      ),
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./error/not-found/not-found.module').then(
        (m) => m.NotFoundModule
      ),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
